import { styled } from '@mui/material/styles';
import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import { Header } from './Header';
import { QueueCountsProvider } from './QueueCountsProvider';
import { Sidebar } from './Sidebar';
import { tokens } from '../../design';

/**
 * AppShell — top-level layout for the authed admin panel. Pixel-matches
 * `design/mockups/admin/layout.html` (LOCK 11):
 *   - Sidebar 220px fixed dark-gradient column
 *   - Main column flex-1 with 54px Header on top + scrollable content
 *
 * QueueCountsProvider wraps everything so the sidebar badges have a
 * context to read; it fetches `GET /admin/queue-counts` (AUT-103) and
 * shares the result with the dashboard count tiles (single fetch, two
 * consumers).
 */

const Shell = styled('div')({
  display: 'flex',
  width: '100%',
  height: '100vh',
  background: tokens.surface.canvas,
  overflow: 'hidden',
});

const Main = styled('main')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

const Content = styled('div')({
  flex: 1,
  padding: 22,
  overflowY: 'auto',
});

export const AppShell = (): ReactElement => {
  return (
    <QueueCountsProvider>
      <Shell>
        <Sidebar />
        <Main>
          <Header />
          <Content>
            <Outlet />
          </Content>
        </Main>
      </Shell>
    </QueueCountsProvider>
  );
};
